export const MARITAL_STATUS = Object.freeze([
    { value: '0', text: 'Married' },
    { value: '1', text: 'Single' },
    { value: '2', text: 'Divorced' },
]);